module.exports = __webpack_public_path__ + "static/sprite-contentandgamedes-c411382f44ec72e679095925220b2cf9.png";